// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import Modal from './components/modal'
import Modal2 from './components/modal2'
import Modal3 from './components/modal3'
import Chart from './components/chart'
import ChartCluster from './components/chartCluster'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'

Vue.config.productionTip = false
Vue.component('modal', Modal)
Vue.component('modal2', Modal2)
Vue.component('modal3', Modal3)
Vue.component('chart', Chart)
Vue.component('chartCluster', ChartCluster)

/* eslint-disable no-new */
Vue.directive('focus', {
  inserted: function (el) {
    el.focus()
  }
})
Vue.axios.defaults.withCredentials = true
// Vue.http.interceptors.push(function(request) {
//   request.credentials = true
//   return function(response) {
//   }
// })

new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js